import { Component, OnInit } from '@angular/core';
import { mountRootParcel } from 'single-spa';

@Component({
  selector: 'app-header',
  template: `<parcel
      [config]="config"
      [mountParcel]="mountRootParcel"
      [customProps]="customProps">
    </parcel>`,
})
export class HeaderComponent implements OnInit {
  public applicationName: string;

  public config: any;
  public mountRootParcel = mountRootParcel;
  public customProps: any = {
    applicationName: ''
  }

  ngOnInit(): void {
    this.applicationName = 'headerApp'
    this.customProps.applicationName = this.applicationName;
    this.config = async () => {
      return window.System.import(this.applicationName);
    }
  }

}
